<template>
    <div>
        <el-dialog
            title="默认充电上限"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="800px">
            <div class="formContent">
                <el-form ref="form" :model="form" label-position='left' label-width='100px' :rules='rules'>
                    <el-form-item label="默认充电时长" prop='time'>
                        <jd-input-intnum v-model="form.time" appendText="小时" style="width:400px"></jd-input-intnum>
                    </el-form-item>
                    <el-form-item label="默认充电金额" prop='money'>
                        <jd-input-price v-model="form.money" style="width:400px"></jd-input-price>
                    </el-form-item>
                    <el-form-item label="卡号" prop='cardNo'>
                        <el-input
                            :disabled='cardNo?true:false'
                            type="textarea"
                            :rows="4"
                            style="width:400px"
                            @input='getAppointsCardNo'
                            @blur='getAppointsCardNoByBlur'
                            placeholder="请输入指定卡号，使用中英文逗号、空格或换行符隔开"
                            v-model="form.cardNo">
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="a-fs-14 a-c-333 a-fw-700" v-if="errorCardNoList.length">以下卡号识别失败：</div>
                <div class="a-flex-wrap a-flex-rfsfs">
                    <el-tag class="a-mt-10 a-mr-10" type="danger" v-for="(item, index) in errorCardNoList" :key="index">{{ item }}</el-tag>
                </div>
            </div>
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">{{ errorCardNoList.length ? '关闭' : "取消"}}</el-button>
                <el-button type="primary"  @click="submit" v-if="!errorCardNoList.length">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import jdInputIntnum from '../../components/formcy/jd-input-intnum.vue';
    export default {
        components: { jdInputIntnum },
        data() {
            var checkTime = (rule, value, callback) => {
                if(this.form.time && (this.form.time <= 0 || this.form.time > 12)) {
                    callback(new Error('时长只能输入1-12小时'));
                } else if(!this.form.time && !this.form.money) {
                    callback(new Error('默认时长和默认金额至少输入一项'));
                } else {
                    callback();
                }
            };
            var checkMoney = (rule, value, callback) => {
                if(this.form.money && (this.form.money <= 0 || this.form.money > 10)) {
                    callback(new Error('金额只能输入0（大于0）-10元'));
                } else if(!this.form.time && !this.form.money) {
                    callback(new Error('默认时长和默认金额至少输入一项'));
                } else {
                    callback();
                }
            };
            return {
                dialogVisible: false,
                cardNo: '',
                cardId: '',
                errorCardNoList: [],
                form: {
                    cardNo: '',
                    cardNoList: [],
                    time: '',
                    money: ''
                },
                rules: {
                    time: [{ validator: checkTime, trigger: 'change' }],//
                    money: [{ validator: checkMoney, trigger: 'change' }],//
                    cardNo: [{required: true, message:'请输入卡号', trigger: 'blur'}]
                }
            };
        },
        mounted () {

        },
        methods:{
            handlerClear () {
                this.$nextTick(()=>{
                    if(this.$refs['form'])
                    this.$refs['form'].clearValidate()
                })
            },
            getAppointsCardNo () {
                if(/[,，; ;\s\n]$/.test(this.form.cardNo[this.form.cardNo.length-1])) {
                    this.form.cardNoList = this.getInputData(this.form.cardNo)
                    this.form.cardNo = this.form.cardNoList.join(',')
                    if(this.form.cardNo) {
                        this.form.cardNo += ','
                    }
                }
            },
            getAppointsCardNoByBlur () {
                this.form.cardNoList = this.getInputData(this.form.cardNo)
                this.form.cardNo = this.form.cardNoList.join(',')
                if(this.form.cardNo) {
                    this.form.cardNo += ','
                }
            },
            getInputData(input) {
                // 使用正则表达式匹配中英文逗号、分号、空格或换行符
                const regex = /[，,;\s\n]+/g;
                const intRegex = /^\d+$/
                // 使用 split 方法分割字符串
                let result = input.split(regex);
                result = result.filter(res=>{
                    return intRegex.test(res)
                })
                // 过滤掉空字符串（如果存在）
                return result.filter(item => item.trim() !== "");
            },
            submit () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let apiUrl = this.cardId ? this.$Config.apiUrl.updateUserCard : this.$Config.apiUrl.updateUserCardByCarNo
                        let reqData = {}

                        if(this.cardId) {
                            reqData = {
                                id: this.cardId,
                                maxChargingMinutes: this.form.time ? this.form.time * 60 : '',
                                maxPrice: this.form.money ? Number((this.form.money * 100).toFixed(0)) : '',
                            }
                        }else {
                            reqData = {
                                "cardNoList": this.form.cardNoList,
                                "maxChargingMinutes": this.form.time ? this.form.time * 60 : '',
                                "maxPrice": this.form.money ? Number((this.form.money * 100).toFixed(0)) : '',
                            }
                        }

                        this.$Axios._post({
                            url: apiUrl,
                            params: {
                                ...reqData
                            }
                        }).then(({data}) => {
                            if(this.cardId) {
                                this.dialogVisible = false
                                this.$emit('success')
                                this.$message.success('操作成功')
                            }else {
                                if(data.errorCardNoList && data.errorCardNoList.length) {
                                    this.errorCardNoList = data.errorCardNoList
                                }else {
                                    this.dialogVisible = false
                                    this.$emit('success')
                                    this.$message.success('操作成功')
                                }
                            }
                            
                        }).catch((error) => {
                            
                        })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
    .a-mr-10{
        margin-right: 10px;
    }
    .tips{
        font-size: 12px;
        color: #909399;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        line-height: 22px;
    }
</style>